<template>
  <div v-if="isSkeleton" class="team-member-option-row max-w-68">
    <AwSkeleton class="h-5 w-5 rounded-full" />
    <AwSkeleton class="h-5 w-60 rounded-full" />
  </div>
  <div v-else class="team-member-option-row max-w-68">
    <TeamMemberAvatar :team-member="item" />
    <TextEllipsis>
      {{ getFullName(item) }}
    </TextEllipsis>
    <AwBadge
      :color="item.offboarded_at ? 'gray' : item.is_independent ? 'yellow' : 'blue'"
      size="sm"
      :is-rounded="true"
    >
      {{ item.offboarded_at ? "Inactif" : item.is_independent ? "Indépendant" : "Salarié" }}
    </AwBadge>
  </div>
</template>

<script setup lang="ts">
import { getFullName } from "@asap/shared/utils/people";
import { computed } from "vue";
import type { TeamMemberOption } from "./team-member-select-v2.model";

const props = defineProps<{
  item: TeamMemberOption;
  loadingRowId: string;
}>();

const isSkeleton = computed(() => props.item.id === props.loadingRowId);
</script>

<style scoped>
.team-member-option-row {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
}
</style>
